import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const logGuardGuard: CanActivateFn = (route, state) => {
  /* if we have data in localstorage than stop user
  from going to login page 
*/

  const _router = inject(Router);
  var array = ['Manager', 'Operator', 'Supervisor'];

  if (localStorage.getItem('authToken')) {
    if (
      array.includes(JSON.parse(localStorage.getItem('userData')!)?.roleName)
    ) {
      _router.navigate(['/dashboard']);
      return false;
    } else if (
      JSON.parse(localStorage.getItem('userData')!)?.roleName == 'SuperAdmin' ||
      JSON.parse(localStorage.getItem('userData')!)?.roleName == 'Admin'
    ) {
      _router.navigate(['/setup']);
      return false;
    }
  }
  return true;
};
